export const refreshToken = async (tokenInfo: { refresh_token?: string, sessionId?: string }, config: { apiUrl: string }) => {
  console.log('WiDE: refreshToken');
  const encodedToken = encodeURIComponent(tokenInfo.refresh_token || '');
  const body = `grant_type=refresh_token&refresh_token=${encodedToken}&client_id=ngApp`;
  const headers: [string, string][] = [['Content-Type', 'application/x-www-form-urlencoded']];
  if (tokenInfo.sessionId) {
    headers.push(['Wt-Session-Id', tokenInfo.sessionId]);
  }
  const response = await fetch(config.apiUrl === '/' ? '/token' : new URL('/token', config.apiUrl), {
    method: 'POST',
    body: body,
    headers,
    mode: 'cors'
  });
  if (response.ok) {
    const json: any = await response.json();
    return json;
  } else {
    console.error(response.statusText);
    const text = await response.text();
    console.error(text);
    return {};
  }
};
